import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import RecipeCalculator from 'components/molecules/Recipe/fragments/Calculator';
import { getRecipe, getRecipeFromSelectedContent } from 'store/programItems';
import {
	actionCreators as recipesAC,
	getDirectionBoundaries,
	getSelectedPortion,
	getTooltipVisibility,
	getVariantList,
} from 'store/recipes';

type RecipeCalculatorOwnPropsType = {
	externalId: string;
	id: string | number;
	selectedContent: any;
};

const mapStateToProps = (state, ownProps: RecipeCalculatorOwnPropsType) => {
	const { externalId, id } = ownProps;
	const selectedPortion = getSelectedPortion(state, externalId);
	const variantList = getVariantList(state, externalId);
	const directionBoundaries = getDirectionBoundaries(state, externalId);
	const tooltipVisibility = getTooltipVisibility(state, externalId);

	if (typeof ownProps.selectedContent === 'object' && ownProps.selectedContent !== null) {
		return {
			externalId,
			selectedPortion,
			variantList,
			directionBoundaries,
			tooltipVisibility,
			recipe: getRecipeFromSelectedContent(ownProps.selectedContent, selectedPortion),
		};
	}

	return {
		externalId,
		selectedPortion,
		variantList,
		directionBoundaries,
		tooltipVisibility,
		recipe: getRecipe(state, id, selectedPortion) as any,
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doPersistPortionSelection: recipesAC.doPersistPortionSelection,
		},
		dispatch
	);
};

export default connect<ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, any>(
	mapStateToProps,
	mapDispatchToProps
)(RecipeCalculator as any);
